module.exports = __webpack_public_path__ + "img/1756265571404-image.jpg.07555531.webp";